<template>
  <module-list-layout :createAction="false" :module="module" v-if="amReady">
    <el-dialog :visible.sync="vosCdrDialog" title="" top="2vh" width="95%">
      <vosCdrViewer v-if="vosCdrDialog" :useUserVos="useUserVos" :vosId="selectedVosId" :cdrDate="selectedCdrDate"></vosCdrViewer>
    </el-dialog>

    <div class="row pl-3 pr-3">
      <!--<div class="col-12 col-md-4 mt-1">
        <small>Search</small>
        <dg-text-field
            :field_span="22"
            :label_span="22"
            field_mark=""
            placeholder="search here"
            @amUpdated="userSearchUpdated"
            :liveUpdate="true"></dg-text-field>
      </div>-->
      <div class="col-12 col-md-3 mb-1" v-if="!useUserVos">
        <dg-select-field
            :field_span="22"
            :label_span="22"
            :options="vosDropdownList"
            :translateLabel="false"
            :translateLabels="false"
            @amUpdated="vosUpdated"
            field_mark=""
            label="Select VOS"
            name="vos_id"
            placeholder="Select VOS"
            rules=""></dg-select-field>
      </div>
      <!-- <div class="col-12 col-md-5 mb-1 pt-3">
         <pagination
             :currentPage="currentPage"
             paginateClass=""
             :page-count="getPagesCount()"
             :page-range="4"
             :margin-pages="2"
             :navigateHandler="navigateToPage"></pagination>
       </div>-->
    </div>

    <app-ag-grid :agGrid="agGrid"></app-ag-grid>

    <el-dialog :visible.sync="deleteDialogVisible" center title="Warning" width="420px">
      <div align="center" class="mt-2 mb-2">You want to remove this record ?</div>
      <span class="dialog-footer" slot="footer">
        <el-button @click="deleteDialogVisible = false" size="small">Cancel</el-button>
        <el-button @click="removeActionApi" size="small" type="danger">Yes</el-button>
      </span>
    </el-dialog>
  </module-list-layout>
</template>

<script>
import actionsCell from './ag-grid/ActionsCell'
import module from './../../index.js'
import {notify} from '@/system-services/notify.js'

import smartAgGridWrapper from "@/components/smart-input-view/AgGridWrapper";

export default {
  components: {
    vosCdrViewer: () => import('./../../cdr-viewer/View'),
    /*pagination: () => import('@/components/pagination/View.vue'),*/
    moduleListLayout: () => import('@/modules-config/layouts/list/View.vue')
  },
  props: {
    userVosToUse: {
      default: false
    }
  },
  data() {
    return {
      isUserRoot: $store.getters['user-state/isUserRoot'],
      useUserVos: false,
      selectedVosId: null,
      selectedCdrDate: null,
      vosDropdownList: [],
      vosCdrDialog: false,
      selectedVos: null,
      vosIsSelectable: false,
      userVOSType: -1,
      deleteDialogVisible: false,
      targetParams: null,
      userSearch: '',
      userSearchTimeOut: null,
      amReady: false,
      module: {...module},
      currentPage: 1,
      pageChunkSize: 12,
      pageCount: 1,
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
            params.api.sizeColumnsToFit()
          }
        },
        columnDefs: [
          {
            field: 'name',
            headerName: 'Date',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellClass: 'text-capitalize'
          },
          {
            width: 120,
            suppressSizeToFit: true,
            sortable: false,
            headerName: 'View',
            headerClass: 'text-capitalize',
            cellClass: 'text-center',
            cellRendererFramework: $vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                action: this.viewCdr,
                label: 'View',
                icon: 'el-icon-view'
              }
            }
          },
          {
            width: 150,
            suppressSizeToFit: true,
            type: 'rightAligned',
            headerName: this.$ml.get('actions'),
            headerClass: 'text-center text-capitalize float-right',
            cellClass: 'text-center',
            cellRendererFramework: $vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                action: this.downloadVosCDR,
                label: 'Download',
                icon: 'el-icon-download'
              }
            }
          }
        ],
        rowData: []
      }
    };
  },
  beforeMount() {
    this.currentPage = parseInt(this.$route.params.listPage)
    let promises = []

    if (this.isUserRoot) {
      this.useUserVos = false
    } else {
      this.useUserVos = true
    }

    if (this.useUserVos) {
      this.getListOfCDRS()
    } else {
      promises.push($store.dispatch('voip-vos-server-api/getDropDownList').then(r => {
        this.vosDropdownList = r
      }))
    }
    Promise.all(promises).then((values) => {
      this.amReady = true
      $vue.nextTick(() => {
        this.bindController()
      })
    })
  },
  methods: {

    viewCdr (params) {
      this.selectedCdrDate = params.name
      this.selectedVosId = this.getVosToUse()
      this.vosCdrDialog = true
    },
    getListOfCDRS () {
      let userCreatedAt = $store.state['user-state'].profile.created_at
      this.getTimeInterval({userCreatedAtDate: userCreatedAt}).then(r => {
        this.agGrid.rowData = []
        for (let i = 0; i < r.length; i++) {
          this.agGrid.rowData.push({name: r[i]})
        }
      })
    },
    vosUpdated (inputField) {
      let val = inputField.field.field_value
      this.selectedVos = val
      this.getListOfCDRS()
    },
    updateField(customParams, newValue, afterSave, fieldName) {
      let data = {}
      data[fieldName] = newValue

      let apiParams = {
        id: customParams.data.id,
        data
      }

      this.updateEntity(apiParams).then(r => {
        afterSave()
      })
    },
    getVosToUse  () {
      return (this.useUserVos)? $store.state['user-state'].profile.vos_server_id : this.selectedVos
    },
    getEntityListData(page) {
      this.getEntityList({vosServerId: this.getVosToUse(), cdrDate: this.userSearch}).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    buildAgGridData(response) {
      this.agGrid.rowData = response.rows
      this.recordsCounter = response.count
      this.amReady = true
    },
    userSearchUpdated(field) {
      // this.agGrid.gridApi.setQuickFilter(val);
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    ...$mapActions(module.info.name + '-api', {
      getEntityList: 'listVOSCdr',
      updateEntity: 'update',
      getTimeInterval: 'getTimeInterval',
      downloadVosCDRAction: 'downloadVosCdr',
      listVOSCdr: 'listVOSCdr'
    }),
    downloadVosCDR(agGridData) {
      if ($store.getters['user-state/isUserCustomer'] || $store.getters['user-state/isUserReseller']) this.userVOSType = 0
      if ($store.getters['user-state/isUserGenerateLive']) this.userVOSType = 2
      let userVOSType = (this.useUserVos)? this.userVOSType : ''
      let username = (this.useUserVos)? $store.state['user-state'].profile.username : ''
      let vosServerId = this.getVosToUse()


      this.downloadVosCDRAction({
        userVOSType, username, vosServerId, cdrDate: agGridData.name
      })
    },
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      $router.push({name: this.module.info.routeName + '->list->page', params: {listPage: page}})
      /*this.getEntityList({page: page, search: this.userSearch}).then(response => {
        this.buildAgGridData(response)
      })*/
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData, propertyName = false, closeDialog = true) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      if (propertyName) {
        this.agGrid.rowData[this.rowToEdit][propertyName] = updatedData;
      } else {
        this.agGrid.rowData[this.rowToEdit] = updatedData;
      }

      if (closeDialog) this.dialogVisible = false;
      this.refreshGrid();
    },
    moduleFormDeleteAction() {
      this.removeAction({
        data: this.dataToBind,
        rowIndex: this.rowToEdit
      })
      this.dialogVisible = false;
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: this.module.info.routeName + '->view', params: { id: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
    },
    removeAction(params) {
      this.targetParams = params
      this.deleteDialogVisible = true
    },
    removeActionApi() {
      let params = this.targetParams
      this.deleteDialogVisible = false
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
